import React from 'react';
import { Route } from "react-router-dom";
import LoaderView from './loader';

const common = require('../common/common');
const env = require("../../config.js").default;

class Logout extends React.Component {
  componentDidMount(){
    doLogout()
  }
  render(){
    return (<Route component={() => <LoaderView headerType={this.props.myHeaderType} />}/>)
  }
}

export function doLogout(doAuthserverLogout){
  common.remove_localStorage("appState");
  common.remove_localStorage("userInfo");
  common.remove_localStorage("filtriTickets");
  common.remove_localStorage("filtriTicketsTipologie");
  common.remove_localStorage("checkout_url");
  common.remove_localStorage("wishList");

  if(doAuthserverLogout)
    window.location.href=env.LOGIN_BACKEND + "accounts/logout/?next=" + encodeURI(env.FRONTEND);
}

export default Logout;
